<template>

    <div class="galaxy::common-canvas-editor-canvas-PageOverlay">

        <OverviewRootBlockToolbar
                v-if="mode == 'overview'"
                :panelStyle="panelStyle" />

        <component
                v-else-if="mode == 'content'"
                :is="panelComponent"
                ref="panel"
                :style="panelStyle"
                @hook:mounted="position"
                @hook:updated="position"/>

        <SelectionAlternatives
            v-if="hasAlternativeSelection"
            v-click-outside="closeAlternativeSelection" />

    </div>

</template>

<script>

	import waitUntil from "wait-until";
	import ClickOutside from 'vue-click-outside'

    import SelectionAlternatives from "./pageOverlay/SelectionAlternatives";
	import OverviewRootBlockToolbar from "./pageOverlay/OverviewRootBlockToolbar"

	export default {

        components: {
            SelectionAlternatives,
            OverviewRootBlockToolbar,
        },

		directives: {
			ClickOutside,
		},

        inject: [
            '$pageComponent',
            'layoutView',
        ],

        provide: {

            // To avoid not found injection error in lower panels.
            options: null,
        },

        data()
        {
            return {
                panelStyle: {},
            };
        },

        mounted()
        {
            // @ugly The use of waitUntil..
            waitUntil(25, 1000, () => !!this.pageComponent, () =>
            {
                // Listen for rendered.
                this.pageComponent.$on('rendered', () => this.initPositioning())
            });

            //
            this.initPositioning();
        },

        methods: {

            initPositioning()
            {
                // Reposition component on resize.
                $(window).bind('resize orientchange', () => this.position());

                // Wait for DOM load.
                $(() => this.position());

                // @ugly Could not wait for image loading because no event triggered.
                // Reposition component on img loads, which may impact the layout.
                setInterval(() => this.position(), 250);
            },

            position()
            {
                // Delegate
                if(this.mode == 'overview')
                    this.positionForOverview();

                else if(this.mode == 'content')
                    this.positionForContent();
            },

            positionForOverview()
            {
                // Get element dimensions.
                let elementDimensions = this.currentSelection.getElementDimensions();

                // Position
                this.panelStyle = {
                    left: elementDimensions.left + 'px',
                    top: elementDimensions.top + 'px',
                    transform: 'scale(' + (1 / this.documentScale) + ')',
                };
            },

			positionForContent()
			{
				// @ugly Not sure why comment check is needed.
				// Abort due to no selection or panel not loaded yet?
				if(!this.$refs['panel'] || this.$refs['panel'].$el.nodeName == '#comment')
					return;

				// @ugly
				if(this.currentSelection.element.closest('body').length == 0)
                {
                	this.selection.setSelection(null);

                	return;
                }

				let elementDimensions = this.currentSelection.getElementDimensions();

				// Determine best left and top.
				const margin = 15;

				let left = Math.min(
					elementDimensions.right + margin, // Next to element.
					this.$pageComponent().element.width() - $(this.$refs['panel'].$el).outerWidth() - margin, // Most right of window.
				);

				let top = Math.max(
					Math.min(
                        Math.max(
                            elementDimensions.top, // Top of element.
                            margin, // Margin from top of window.
                            this.layoutView.element.closest('html').scrollTop() + margin, // Visible top.
                        ),
                        this.$pageComponent().element.height() - $(this.$refs['panel'].$el).outerHeight() - margin,
                    ),
                    15
				);

				// Position
				this.panelStyle = {
					left: left + 'px',
					top: top + 'px',
				};
			},

			closeAlternativeSelection()
            {
				this.selection.clearAlternatives();
            },

        },

        computed: {

            pageComponent()
            {
                return this.$pageComponent();
            },

            selection()
            {
                return this.pageComponent?.selection;
            },

            hasAlternativeSelection()
            {
                return (this.selection?.alternativeSelection?.editors || []).length > 1;
            },

            currentSelection()
            {
                return this.selection?.currentSelection;
            },

            panelComponent()
            {
                return this.currentSelection?.panelComponent;
            },

            mode()
            {
                if(!this.pageComponent || !this.currentSelection)
                    return null;

                else if(this.pageComponent.activeMode == 'overview' && this.currentSelection.isRootBlock)
                    return 'overview';

                else if(this.pageComponent.activeMode == 'content' && this.panelComponent)
                    return 'content';

                else
                    return null;
            },

            documentScale()
            {
                return this.pageComponent.scale;
            },

        },

        watch: {

            async 'currentSelection'()
            {
                this.position();
            },

            'mode'()
            {
                this.position();
            },

        },

    }

</script>

<style lang="scss" scoped>

    .galaxy\:\:common-canvas-editor-canvas-PageOverlay {
        font-family: "Rubik", sans-serif !important;
        font-weight: normal;

        > * {
            z-index: 60;
        }
    }

</style>